// extracted by mini-css-extract-plugin
export default {"container":"page2_container__lkxcN","div":"page2_div__IGwhi","topic":"page2_topic__mzn8j"};